export const apiTokensMessages = {
  MAX_REQUESTS_PER_24H: `You have reached the maximum number of requests allowed in a 24-hour period.`,
}

export const tokensModal = {
  title: 'Buying data with tokens',
  content: `
The MetOceanWorks Data platform uses a token-based system to simplify and optimize data purchases. Tokens act as a flexible digital currency, allowing users to buy data without the hassle of repeated transactions. For occasional users, the pay-as-you-go option offers convenience, but for those with larger or recurring data requirements, purchasing tokens in bulk provides a more cost-effective solution.

By opting for bulk purchases, users can secure significant savings while enjoying the flexibility of redeeming tokens when needed, making it a smarter and more economical choice for regular users of the platform.

Each year of data costs one token.

If applicable, V.A.T. is added and charged at the time of purchase of tokens.
`
}

export const tokensPermissionsModal = {
  title: 'API token permissions',
  content: `
To ensure secure and controlled access to the MetOceanWorks platform, API tokens are assigned specific permissions. These permissions dictate the level of access granted to each token. With **Read only** permissions, users can retrieve data already purchased data. **Full access** permissions allow users to additionally purchase data points. This only applies to users with tokens or subscription access. 
`
}

export const lastAdminModal = {
  title: `Can't leave yet`,
  content: `You're the only admin of this organisation. Promote another member to admin first — then you'll be able to leave. You can change a member's role in the list behind this dialog.`,
}

export const dataSourcesModal = {
  title: 'Customer data sources',
  content: `
  The MetOceanAtlas platform supports a **custom data source** feature. This functionality is particularly beneficial for organisations with proprietary data or those seeking to combine external datasets with MetOceanWorks offerings.

  For implementing custom data sources with cost estimates, please reach out to our team - [Andrew Watson](mailto:andrew.watson@metoceanworks.com).
`
}

export const permissionsModal = {
  title: 'User permissions on MetOceanAtlas',
  content: `
The MetOceanAtlas platform offers a range of user permissions to ensure secure and efficient data access. The permissions are as follows:
- **Admin**: Full access to all features, including user management and data purchases.
- **Member**: Standard access to data and features without administrative privileges.
- **Collaborator**: Limited access, primarily for viewing data without modification rights.

`
}

export const companyAddress = {
  name: 'MetOceanWorks limited',
  address_1: "Office 9, Dalton House",
  address_2: '60 Windsor Avenue',
  address_3: 'London',
  postcode: 'SW19 2RR',
  address6: 'United Kingdom',
  vatNumber: 'GB 150 6652 22',
  companyNumber: '08078702',
}

export const vatWarningMessage = {
  title: '',
  content: `We will not charge the V.A.T. on this payment. As a UK-based business, we are required to charge Value Added Tax (V.A.T.) on all applicable products and services. However, if you qualify for a **V.A.T. exemption**, you can confirm this by selecting the appropriate option. Please note that by doing so, you certify that your exemption status is valid and accurate. Any misrepresentation of exemption status may result in the reversal of the exemption and additional charges.`
}

export const introSignUpMessage = `
MetOceanAtlas is your gateway to trusted **marine and atmospheric data**. Explore **wind, wave, current and water level** data through a clean, user-friendly interface. 
`

// MetOceanAtlas puts reliable metocean data at your fingertips - fast, flexible, and built for offshore professionals.

export const featuresDescription = {
  can_export_layers: {
    title: "Can export data layers",
    content: "User can export values from data layers."
  },
  direct_download: {
    title: "Can use API with direct download",
    content: "User can access end point."
  }
}
